module.exports = __webpack_public_path__ + "static/media/info-security-image.c4ce4d7f.webp";